exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "aside#landing-bg[_v-0a462969]{-webkit-transition:all 1.5s ease-in-out;transition:all 1.5s ease-in-out;min-height:100%;min-height:100vh;width:100%;width:100vw;background-size:cover;background-repeat:no-repeat;background-position:50%;background-color:#f2f2f2;position:fixed;top:0;left:0;z-index:1;opacity:0;display:block}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-0a462969&scoped=true!./~/sass-loader?indentedSyntax!./~/vue-loader/lib/selector.js?type=style&index=0!./public/_src/_vue/Background.vue
 ** module id = 10
 ** module chunks = 0
 **/